<template>
  <div>
    <AdminNavbar />
    <div v-if="!entriesLoaded">
      <div class="d-flex justify-content-center">
        <div class="col col-sm-8 col-md-6">
          <LoadingBar />
        </div>
      </div>
    </div>
    <div v-else>
      <div
        class="pt-3"
        :class="{ container: !wideLayout, 'container-fluid': wideLayout }"
      >
        <div v-if="getAdminEntries">
          <div class="row">
            <div
              class="col-12 col-sm-12 col-md-12"
              :class="{
                'col-lg-6': hasActiveEntry
              }"
            >
              <AdminSortTable
                :entries="tableEntries(this.entries)"
                :extraColumnKeys="extraColumnKeys"
                :evaluation="evaluation"
                @setActiveEntry="setActiveEntry"
              />
              <AdminExport :entries="exportEntries(this.entries)" />
            </div>
            <div class="col" v-if="hasActiveEntry">
              <AdminActiveEntry
                v-bind="activeEntryData"
                v-if="activeEntry !== ''"
                ><AdminCustomEntry :value="activeEntryData.value"
              /></AdminActiveEntry>
              <CustomAlert v-else title="" icon="bi-info-circle"
                >Select a user from the <b>participants</b> to see the
                submission data.</CustomAlert
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import DatastoreAPI from "@/helpers/DatastoreAPI";
import { config, exportEntries, tableEntries } from "@/admin";

import AdminNavbar from "@/admin/components/AdminNavbar";
import AdminSortTable from "@/admin/components/AdminSortTable";
import AdminExport from "@/admin/components/AdminExport";
import AdminActiveEntry from "@/admin/components/AdminActiveEntry";
import AdminCustomEntry from "@/admin/components/AdminCustomEntry";

import LoadingBar from "@/components/ui/LoadingBar";
import CustomAlert from "@/components/ui/CustomAlert";

export default {
  name: "AdminView",
  mixins: [DatastoreAPI],
  components: {
    AdminNavbar,
    AdminSortTable,
    AdminExport,
    LoadingBar,
    AdminActiveEntry,
    CustomAlert,
    AdminCustomEntry
  },
  data() {
    return {
      activeEntry: "",
      extraColumnKeys: config.extraColumnKeys,
      hasActiveEntry: config.hasActiveEntry,
      evaluation: config.evaluation,
      wideLayout: config.wideLayout
    };
  },
  computed: {
    ...mapGetters("datastore", ["getAdminEntries"]),
    ...mapState("datastore", ["entriesLoaded"]),
    activeEntryData() {
      return this.getAdminEntries.find(
        (entry) => entry.onid === this.activeEntry
      );
    },
    entries() {
      let entries = [...this.getAdminEntries];

      /**
       * Filter out entries that do not have a fullname.
       */
      entries = entries.filter((entry) => {
        return entry.fullname;
      });

      return entries;
    }
  },
  methods: {
    tableEntries,
    exportEntries,
    setActiveEntry(entry) {
      this.activeEntry = entry;
    }
  },
  created() {
    this.readEntries();
  }
};
</script>
